import { Divider } from "@material-ui/core";
import MenuIcon from "@mui/icons-material/Menu";
import { Collapse, Grid, Toolbar } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import { lazy, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import WhiteSpace from "react-white-space";
import {
  ChangeShowNavigation,
  selectCommonData,
} from "../../Store/Slices/CommonDataSlice";
import urls from "../../urls.json";
import Buyer from "../Icons/Buyer";
import Home from "../Icons/Home";
import Profile from "../Icons/Profile";
import Seller from "../Icons/Seller";
import { toolbarStyle } from "./toolbarStyle";
const AccountMenu = lazy(() => import("./AccountMenu"));
const LoginMenu = lazy(() => import("./LoginMenu"));
const MainMenu = lazy(() => import("./MainMenu"));
const ResponsiveMenu = lazy(() => import("./ResponsiveMenu"));

const ToolbarForm = () => {
  const history = useHistory();
  const classes = toolbarStyle();
  const { t } = useTranslation("mainContent");
  const [userName, setUserName] = useState("");
  const [orgName, setOrgName] = useState<any>(null);
  const [anchorElUser, setAnchorElUser] = useState<any>(null);
  const [anchorElUserSm, setAnchorElUserSm] = useState<any>(null);
  const [anchorElServices, setAnchorElServices] = useState<any>(null);
  const [anchorElServicesSm, setAnchorElServicesSm] = useState<any>(null);
  const CommonData = useSelector(selectCommonData);
  const profileInfo = CommonData.profileInfo;
  const [token, setToken] = useState(localStorage.getItem("manaToken"));
  const hasWindow = typeof window !== "undefined";
  const [width, setWidth] = useState<any>(hasWindow ? window.innerWidth : null);
  const [scrollPosition, setScrollPosition] = useState<any>(0);
  const [showNavigation, setShowNavigation] = useState<any>(true);
  const [showLogoImage, setShowLogoImage] = useState<any>(
    history.location.pathname !== "/"
  );
  const [android, setAndroid] = useState(false);
  const [ios, setIos] = useState(false);
  const dispatch = useDispatch();
  const {} = useForm<any>({
    mode: "onBlur",
  });
  useEffect(() => {
    var userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      setAndroid(true);
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setIos(true);
    }
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", (event) => {
      if (scrollPosition >= window.scrollY) {
        setScrollPosition(window.scrollY);
        if (!showNavigation) {
          setShowNavigation(true);
        }
      } else {
        setScrollPosition(window.scrollY);
        if (!showLogoImage) {
          setShowLogoImage(true);
        }
        if (showNavigation) {
          setShowNavigation(false);
        }
      }
    });
  }, [window.scrollY]);
  useEffect(() => {
    setShowNavigation(CommonData.showNavigation);
    if (!CommonData.showNavigation) {
      setShowLogoImage(true);
    }
  }, [CommonData.showNavigation]);

  const handleResize = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);
  useEffect(() => {
    setShowLogoImage(history.location.pathname !== "/");
  }, [history.location.pathname]);
  useEffect(() => {}, [width]);
  useEffect(() => {
    setWidth(hasWindow ? window.innerWidth : null);
  }, [hasWindow]);
  useEffect(() => {
    setToken(localStorage.getItem("manaToken"));
    if (!!profileInfo && !!profileInfo.isReal && profileInfo.isReal === "0") {
      setOrgName(profileInfo.orgName);
    } else {
      setOrgName("");
    }
    setUserName(
      (!!profileInfo && !!profileInfo.name ? profileInfo?.name + " " : "") +
        (!!profileInfo && !!profileInfo?.lastName ? profileInfo?.lastName : "")
    );
    setAnchorElUser(null);
    setAnchorElUserSm(null);
    setAnchorElServices(null);
    setAnchorElServicesSm(null);
  }, [
    profileInfo,
    history.location.pathname,
    userName,
    orgName,
    token,
    localStorage.getItem("manaToken"),
  ]);
  const handleOpenUserMenu = (event: any) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleOpenUserMenuSm = (event: any) => {
    setAnchorElUserSm(event.currentTarget);
  };
  const handleOpenServicesMenu = (event: any) => {
    setAnchorElServices(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleCloseUserMenuSm = () => {
    setAnchorElUserSm(null);
  };
  const handleCloseServicesMenu = () => {
    setAnchorElServices(null);
  };
  const signUpHandler = () => {
    history.push("/sign-up");
  };
  // const adPages =
  //     [
  //         { index: 1, label: t("purchaseOrder"), url: "/purchase-order", disabled: false },
  //         { index: 2, label: t("whitePlate"), url: urls.pelakSefid, newWindow: true, disabled: false },
  //     ];
  const pages = {
    parentItem: {
      index: 1,
      label: t("newCar"),
      url: "/purchase-order",
      state: { state: "NEW" },
      disabled: false,
    },
    submMenuItems: [
      { index: 1, label: t("purchase"), url: "/prchs-cntnt", disabled: false },
      {
        index: 2,
        label: t("newCar"),
        url: "/purchase-order",
        state: { state: "NEW" },
        disabled: false,
      },
      {
        index: 3,
        label: t("usedCar"),
        url: "/purchase-order",
        state: { state: "USED" },
        disabled: false,
      },

      { index: 4, label: t("facility"), url: "/fac-form", disabled: false },
    ],
  };
  const pages2 = {
    parentItem: {
      index: 1,
      label: t("newCar"),
      url: "/purchase-order",
      state: { state: "NEW" },
      disabled: false,
    },
    submMenuItems: [
      {
        index: 1,
        label: t("manaPrices"),
        url: "/mana-prices",
        disabled: false,
      },
      {
        index: 2,
        label: t("priceEstimate"),
        url: "/price-estimate",
        disabled: false,
      },
    ],
  };
  const pages3 = {
    parentItem: {
      index: 1,
      label: t("advertises"),
      url: "/purchase-order",
      disabled: false,
    },
    submMenuItems: [
      {
        index: 1,
        label: t("advertises"),
        url: "/purchase-order",
        disabled: false,
      },
      {
        index: 2,
        label: t("stock"),
        url: "/stock",
        disabled: false,
      },
    ],
  };
  const responsePages = {
    parentItem: {
      index: 1,
      label: t("registerPurchaseOrder"),
      url: "/purchase-order",
      state: { state: "NEW" },
      disabled: false,
    },
    submMenuItems: [
      { index: 1, label: t("purchase"), url: "/prchs-cntnt", disabled: false },
      {
        index: 2,
        label: t("newCar"),
        url: "/purchase-order",
        state: { state: "NEW" },
        disabled: false,
      },
      {
        index: 3,
        label: t("usedCar"),
        url: "/purchase-order",
        state: { state: "USED" },
        disabled: false,
      },

      { index: 4, label: t("facility"), url: "/fac-form", disabled: false },
    ],
  };
  const responsePages1 = {
    parentItem: {
      index: 4,
      label: t("salesOrder"),
      url: "/sls-cntnt",
      disabled: false,
    },
    submMenuItems: [],
  };
  const responsePages6 = {
    parentItem: {
      index: 4,
      label: t("advertises"),
      disabled: false,
    },
    submMenuItems: [
      {
        index: 4,
        label: t("advertises"),
        url: "/purchase-order",
        disabled: false,
      },
      {
        index: 7,
        label: t("stock"),
        url: "/stock",
        disabled: false,
      },
    ],
  };
  const responsePages5 = {
    parentItem: { index: 4, label: t("units"), url: "/unts", disabled: false },
    submMenuItems: [],
  };
  const responsePages2 = {
    parentItem: {
      index: 1,
      label: t("carPrice"),
      state: { state: "NEW" },
      disabled: false,
    },
    submMenuItems: [
      {
        index: 5,
        label: t("manaPrices"),
        url: "/mana-prices",
        disabled: false,
      },
      {
        index: 7,
        label: t("priceEstimate"),
        url: "/price-estimate",
        disabled: false,
      },
    ],
  };
  const responsePages3 = {
    parentItem: {
      index: 8,
      label: t("infoPage"),
      url: "/info",
      disabled: false,
    },
    submMenuItems: [],
  };
  const responsePages4 = {
    parentItem: {
      index: 10,
      label: t("kermanMotor"),
      url: urls.kermanmotor,
      newWindow: true,
      disabled: false,
    },
    submMenuItems: [],
  };
  const navigation = (
    <div className="row justify-content-center w-100 ml-0 mr-0">
      <ul
        id="toolbar_id"
        style={{
          maxWidth: "max-content",
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          height: "100%",
          justifyContent: "center",
          visibility: "visible",
          flex: "1 0 auto",
          marginTop: "10px",
        }}
      >
        {/* <li className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}>
          <a
            href="/purchase-order"
            className={[classes.menuTtl, "element"].join(" ")}
          >
            {t("advertises")}
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
          </a>
        </li> */}

        <li className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}>
          <MainMenu pages={pages3} label={t("advertises")} />
        </li>
        <li className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}>
          <MainMenu pages={pages} label={t("allPurchase")} />
        </li>
        <li
          className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}
          style={{ marginRight: "15px", marginLeft: "15px" }}
        >
          <a
            href="/sls-cntnt"
            className={[classes.menuTtl, "element"].join(" ")}
          >
            {t("sell")}
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
          </a>
        </li>
        <li>
          <MainMenu pages={pages2} label={t("prices")} />
        </li>
        <li
          className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}
          style={{ marginRight: "15px", marginLeft: "15px" }}
        >
          <div
            onClick={() => window.open(urls.kermanmotor)}
            className={[classes.menuTtl, "element"].join(" ")}
          >
            {t("kermanMotor")}
          </div>
        </li>
        <li
          className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}
          style={{ marginRight: "15px", marginLeft: "15px" }}
        >
          <a href="/info" className={[classes.menuTtl, "element"].join(" ")}>
            {t("infoPage")}
          </a>
        </li>
        <li className={[classes.menuContainer, "mt-auto mb-auto"].join(" ")}>
          <a href="/unts" className={[classes.menuTtl, "element"].join(" ")}>
            {t("units")}
          </a>
        </li>
      </ul>
    </div>
  );
  return (
    <AppBar
      id="toolbar_section_id"
      className={classes.appBar}
      sx={{ bgcolor: "transparent" }}
      position="static"
    >
      <Container
        maxWidth="xl"
        sx={{ maxWidth: "100% !important" }}
        className={
          history.location.pathname === "/" &&
          showNavigation &&
          window.scrollY === 0 &&
          !(android || ios)
            ? classes.toolbarContainerTop
            : classes.toolbarContainer
        }
      >
        {width > 1295 ? (
          <Box sx={{ flexGrow: 1, display: "contents" }}>
            <Toolbar
              sx={{
                flexGrow: 1,
                maxWidth: "1600px",
                marginRight: "auto",
                marginLeft: "auto",
                paddingRight: "10px",
                paddingLeft: "10px",
              }}
              disableGutters
              className={classes.toolbar}
            >
              <div
                onMouseOver={() => dispatch(ChangeShowNavigation(true))}
                style={{ display: "flex", width: "100%", height: "inherit" }}
              >
                <div className="row ml-0 mr-0 mt-3" style={{ width: "40%" }}>
                  <div className={[classes.menuContainer].join(" ")}>
                    <div
                      className={classes.gidCntnr}
                      style={{ display: "flex" }}
                    >
                      <div
                        onClick={() => history.push("/")}
                        className={classes.gud}
                      >
                        <Home
                          fill="white"
                          style={{ fontSize: "30px", width: "50px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={[classes.menuContainer].join(" ")}>
                    <div
                      className={classes.gidCntnr}
                      style={{ display: "flex" }}
                    >
                      <div
                        onClick={() => history.push("/sls-cntnt")}
                        className={classes.gud}
                      >
                        <Seller fill="white" />
                        <WhiteSpace />
                        <WhiteSpace />
                        <WhiteSpace />
                        <WhiteSpace />
                        فروشنـــده‌
                      </div>
                    </div>
                  </div>
                  <div className={[classes.menuContainer].join(" ")}>
                    <div
                      className={classes.gidCntnr}
                      onClick={() => history.push("/prchs-cntnt")}
                      style={{ display: "flex" }}
                    >
                      <div className={classes.gud}>
                        <Buyer fill="white" />
                        <WhiteSpace />
                        <WhiteSpace />
                        <WhiteSpace />
                        <WhiteSpace />
                        خریــــدار
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="row justify-content-center ml-0 mr-0"
                  style={{ width: "20%" }}
                >
                  {!showLogoImage ? (
                    <div
                      style={{
                        display: "table",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "table-cell",
                          verticalAlign: "middle",
                          height: "100%",
                        }}
                      >
                        <ReactPlayer
                          playsinline
                          width="100%"
                          style={{ minWidth: "400px" }}
                          loop={false}
                          onEnded={() => setShowLogoImage(true)}
                          height="auto"
                          muted={true}
                          playing={true}
                          url={
                            process.env.PUBLIC_URL + "/videos/logo-motion.mp4"
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "table",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "table-cell",
                          verticalAlign: "middle",
                          height: "100%",
                        }}
                      >
                        <img
                          alt="image Alt and Title"
                          className={[
                            history.location.pathname === "/" &&
                            window.scrollY === 0 &&
                            showNavigation
                              ? classes.logoTop
                              : classes.logo,
                            classes.logoMotion,
                          ].join(" ")}
                          onClick={() => history.push("/")}
                          width={
                            history.location.pathname === "/" &&
                            window.scrollY === 0
                              ? "118"
                              : "45"
                          }
                          height={
                            history.location.pathname === "/" &&
                            window.scrollY === 0
                              ? "80"
                              : "32"
                          }
                          style={{
                            width:
                              history.location.pathname === "/" &&
                              window.scrollY === 0 &&
                              showNavigation
                                ? "118px"
                                : "80px",
                            height:
                              history.location.pathname === "/" &&
                              window.scrollY === 0 &&
                              showNavigation
                                ? "80px"
                                : "54px",
                          }}
                          src={
                            process.env.PUBLIC_URL + "/images/white-logo.svg"
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="p-0"
                  style={{ width: "40%", marginLeft: "0", marginRight: "auto" }}
                >
                  <div
                    className="row w-100 ml-0 mr-0 h-100"
                    style={{ justifyContent: "flex-end" }}
                  >
                    {!!token ? (
                      <Box
                        className="mt-3"
                        sx={{
                          flexGrow: 1,
                          display: { xs: "flex", md: "flex", lg: "flex" },
                        }}
                        dir="ltr"
                      >
                        <Box
                          sx={{
                            flexGrow: 0,
                          }}
                          className={classes.box}
                        >
                          {token != null &&
                          token != "" &&
                          token != undefined ? (
                            <>
                              <IconButton
                                style={{
                                  pointerEvents: "visible",
                                  paddingLeft: "20px",
                                }}
                                onClick={handleOpenUserMenu}
                                sx={{ p: 0 }}
                              >
                                <Typography
                                  textAlign="center"
                                  style={{ marginRight: "5px" }}
                                >
                                  {!!orgName ? (
                                    <>
                                      <div className="row w-100 m-0 justify-content-center">
                                        {userName}
                                      </div>
                                      <div className="row w-100 m-0 justify-content-center">
                                        {orgName}
                                      </div>
                                    </>
                                  ) : (
                                    <>{userName}</>
                                  )}
                                </Typography>
                                <Profile fill="white" />
                              </IconButton>
                              <Menu
                                sx={{ mt: "45px", zIndex: 999999 }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                keepMounted
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                className={classes.profileMenu}
                                open={!!anchorElUser ? anchorElUser : false}
                                onClose={handleCloseUserMenu}
                              >
                                <AccountMenu reload={anchorElUser} />
                              </Menu>
                            </>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>
                    ) : (
                      <>
                        {/* <div
                          className={[classes.signUpCntnr, "mt-3"].join(" ")}
                          onClick={signUpHandler}
                        >
                          <div className={classes.signUp}>{t("signUp")}</div>
                        </div>
                        <div
                          className={[classes.loginLine, "mt-3"].join(" ")}
                          style={{ marginLeft: "3px", marginRight: "3px" }}
                        ></div> */}
                        <div className={[classes.loginCntnr, "mt-3"].join(" ")}>
                          <LoginMenu
                            label={
                              <div
                                className="ml-0 mr-0 w-100"
                                style={{
                                  pointerEvents: "visible",
                                  display: "table-cell",
                                  verticalAlign: "middle",
                                  marginRight: "12px",
                                  cursor: "pointer",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  style={{
                                    margin: "auto",
                                    display: "flex",
                                  }}
                                >
                                  <img
                                    style={{
                                      padding: "5px",
                                      height: "30px",
                                    }}
                                    alt="image Alt and Title"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/images/Login.svg"
                                    }
                                  />
                                  <div className={classes.login}>
                                    {t("login")}
                                  </div>
                                </Grid>
                              </div>
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Toolbar>
          </Box>
        ) : (
          <Box className="h-100" sx={{ flexGrow: 1, display: "flex" }}>
            <Toolbar
              sx={{
                flexGrow: 1,
                display: { xs: "grid", md: "grid", lg: "grid" },
              }}
              disableGutters
              className={classes.toolbar}
            >
              <div className="row justify-content-center">
                <div
                  style={{
                    position: "fixed",
                    top: "20px",
                    width: "max-content",
                    right: "0",
                    zIndex: 999,
                  }}
                >
                  <div style={{ marginRight: "20px", width: "max-content" }}>
                    <IconButton
                      style={{
                        pointerEvents: "visible",
                      }}
                      id="resp_menu"
                      aria-label="res_btn"
                      onClick={handleOpenServicesMenu}
                      sx={{ p: 0 }}
                    >
                      <MenuIcon className={classes.toolbarIconRes} />
                    </IconButton>
                    <Menu
                      sx={{ mt: "50px", borderRadius: "10px" }}
                      id="menu-appbar"
                      anchorEl={anchorElServices}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      className={classes.profileMenu}
                      open={!!anchorElServices ? anchorElServices : false}
                      onClose={handleCloseServicesMenu}
                    >
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages6}
                      />
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages}
                      />
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages1}
                      />
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages2}
                      />
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages4}
                      />
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages3}
                      />
                      <div className="row w-100 m-0 justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={11}>
                          <Divider style={{ backgroundColor: "black" }} />
                        </Grid>
                      </div>
                      <ResponsiveMenu
                        close={handleCloseServicesMenu}
                        menu={responsePages5}
                      />
                    </Menu>
                  </div>
                </div>
                {!showLogoImage ? (
                  <div
                    style={{
                      display: "table",
                      height: "40px",
                      maxHeight: "40px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "table-cell",
                        verticalAlign: "middle",
                        maxHeight: "40px",
                        height: "40px",
                      }}
                    >
                      <ReactPlayer
                        playsinline
                        width="auto"
                        loop={false}
                        onEnded={() => setShowLogoImage(true)}
                        height="60px"
                        muted={true}
                        playing={true}
                        url={process.env.PUBLIC_URL + "/videos/logo-motion.mp4"}
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "table",
                      height: "40px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "table-cell",
                        verticalAlign: "middle",
                        height: "40px",
                      }}
                    >
                      <img
                        alt="image Alt and Title"
                        className={[
                          history.location.pathname === "/" && classes.logo,
                          classes.logoMotion,
                        ].join(" ")}
                        onClick={() => history.push("/")}
                        width={
                          history.location.pathname === "/" &&
                          window.scrollY === 0
                            ? "60"
                            : "45"
                        }
                        height={
                          history.location.pathname === "/" &&
                          window.scrollY === 0
                            ? "auto"
                            : "32"
                        }
                        style={{
                          width:
                            history.location.pathname === "/" &&
                            window.scrollY === 0 &&
                            showNavigation
                              ? "50px"
                              : "54px",
                          height:
                            history.location.pathname === "/" &&
                            window.scrollY === 0 &&
                            showNavigation
                              ? "auto"
                              : "54px",
                        }}
                        src={process.env.PUBLIC_URL + "/images/white-logo.svg"}
                      />
                    </div>
                  </div>
                )}
                <Box
                  style={{
                    width: "60px",
                    position: "fixed",
                    left: "0",
                    top: "20px",
                  }}
                >
                  <div
                    className="row w-100 m-0 justify-content-center"
                    dir="ltr"
                  >
                    <Grid item sm={12} xs={12} className="text-center p-0">
                      <Box
                        sx={{
                          flexGrow: 0,
                        }}
                        className={classes.box}
                      >
                        {token != null && token != "" && token != undefined ? (
                          <>
                            <IconButton
                              onClick={handleOpenUserMenuSm}
                              sx={{ p: 0 }}
                            >
                              <Profile
                                fill="white"
                                className={classes.toolbarIconRes}
                              />
                            </IconButton>
                            <Menu
                              sx={{
                                mt: "45px",
                                borderRadius: "10px",
                                display: { lg: "none" },
                              }}
                              id="menu-appbar-sm"
                              anchorEl={anchorElUserSm}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              keepMounted
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              className={classes.profileMenu}
                              open={!!anchorElUserSm ? anchorElUserSm : false}
                              onClose={handleCloseUserMenuSm}
                            >
                              <AccountMenu reload={anchorElServicesSm} />
                            </Menu>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Grid>
                  </div>
                </Box>
                {token == null || token == "" || token == undefined ? (
                  <div
                    style={{
                      width: "60px",
                      position: "absolute",
                      left: "10px",
                      top: "20px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <LoginMenu
                        label={
                          <div
                            style={{
                              cursor: "pointer",
                              color: "white",
                              fontSize: "12px",
                              pointerEvents: "visible",
                            }}
                          >
                            <img
                              style={{
                                cursor: "pointer",
                                padding: "5px",
                                height: "30px",
                              }}
                              alt="image Alt and Title"
                              src={process.env.PUBLIC_URL + "/images/Login.svg"}
                            />
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Toolbar>
          </Box>
        )}
      </Container>
      <Box
        sx={{
          display: { xs: "none", sm: "none", md: "block", lg: "block" },
          width: "100%",
        }}
      >
        <Collapse
          in={
            showNavigation &&
            history.location.pathname === "/" &&
            window.scrollY === 0
          }
          className={classes.navigationTop}
        >
          {navigation}
        </Collapse>
        <Collapse
          in={
            showNavigation &&
            (history.location.pathname !== "/" || window.scrollY !== 0)
          }
          className={classes.navigation}
        >
          {navigation}
        </Collapse>
      </Box>
    </AppBar>
  );
};

export default ToolbarForm;
